import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { paths, VIDEO_SOURCE } from '@app/constants';
import { MyChartsService } from '@app/core/features/charts-manager/my-charts/my-charts.service';
import { TouchService } from '@app/core/services/touch/touch.service';
import { BaseComponent } from '@app/shared/components/base/base/base.component';
import { isMobileView } from '@app/utils';
import { TranslateService } from '@ngx-translate/core';
import { OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-how-to-guide',
  templateUrl: './how-to-guide.component.html',
  styleUrls: ['./how-to-guide.component.scss']
})
export class HowToGuideComponent extends BaseComponent implements OnInit {

  public isMobileView: boolean;
  public customOptions: OwlOptions = {
    loop: false,
    autoHeight: true,
    autoWidth: false,
    mergeFit: true,
    dots: false,
    items: 1,
    dotsEach: 1,
  };
  public slidesStore: any;
  public activeSlide: SlidesOutputData = {
    startPosition: 0
  };
  private videoContents$ = new BehaviorSubject<string[]>([]);
  private videoSteps$ = new BehaviorSubject<string[]>([]);
  private videoContents = [];
  private videoSteps = [];
  public activeIndex: number = 0;

  constructor(
    private router: Router,
    // this service is in-use by template, please do not remove
    public touchService: TouchService,
    private translateService: TranslateService,
    private sanitizer: DomSanitizer,
    private myChartsService: MyChartsService,
  ) {
    super();
  }

  ngOnInit() {
    this.isMobileView = isMobileView();
    this.myChartsService.checkChangedLanguage
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(() => {
      this.getVideos();
    });
    this.getVideos();
  }

  public navigateRedeem(event) {
    event.preventDefault();

    this.router.navigate([paths.LIGHT_HOUSE_CHART, paths.REDEEM_VOUCHER], { replaceUrl: false });
  }
  public navigateMyChart(event) {
    event.preventDefault();

    this.router.navigate([paths.CHARTS_MANAGER, paths.MY_CHART], { replaceUrl: false });
  }

  private getVideos() {
    forkJoin([
      this.translateService.get('HOW_TO_GUIDE.VIDEO.STEPS'),
      this.translateService.get('HOW_TO_GUIDE.VIDEO.CONTENT')
    ]).subscribe(([stepsData, contentData]) => {
      this.videoSteps$.next(stepsData);
      this.videoContents$.next(contentData);

      this.videoSteps = this.videoSteps$.value.concat(stepsData);
      this.videoContents = this.videoContents$.value.concat(contentData);

      this.slidesStore = VIDEO_SOURCE.HOW_TO.map((youtubeKey) => {
        return {
          safeUrl: '',
          youtubeKey: youtubeKey,
          videoSteps: this.videoSteps,
          videoContents: this.videoContents
        };
      });

      this.updateVideoSrc(this.activeIndex);
    });
  }

  public getPassedData(data: SlidesOutputData) {
    this.activeSlide = data;
    this.activeIndex = this.activeSlide.startPosition;
    this.updateVideoSrc(this.activeIndex);
  }

  private updateVideoSrc(activeIndex: number) {
    this.slidesStore.forEach((slide, idx) => {
      const youtubeUrl = `https://www.youtube.com/embed/${slide.youtubeKey}`;
      const updatedUrl = idx === activeIndex ? `${youtubeUrl}?autoplay=1` : youtubeUrl;
      slide.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(updatedUrl);
    });
  }

}
